// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../../../assets/images/svg/file-icon.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, "#cv .files-wrapper{font-family:\"HelveticaNeuyeCyr-Roman\",\"Helvetica\",sans-serif;color:#2EA0DC;cursor:pointer}#cv .files-wrapper .file{display:flex}#cv .files-wrapper .file:before{content:'';background:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") no-repeat;min-width:12px;height:16px;margin-right:5px;display:inline-block}#cv .files-wrapper .file:last-child{margin-bottom:0}\n", ""]);
// Exports
module.exports = exports;
